/**
 * Equivalente a `path.posix.extname`, sem importar `path`.
 *
 * `OptimizeImage` e o loader rodam também no navegador (os componentes chamam o
 * loader nos dois lados), e ali `path` não é o do Node: é o polyfill que
 * o bundler do consumidor injetar — ou um stub, que quebra a hidratação. Ver o
 * TD-4 em docs/tech-debts.md. O teste compara caso a caso com `path.extname`.
 */
export const extname = (p: string): string => {
  const trimmed = p.replace(/\/+$/, '');
  const base = trimmed.slice(trimmed.lastIndexOf('/') + 1);
  if (base === '..') return '';
  const dot = base.lastIndexOf('.');
  return dot <= 0 ? '' : base.slice(dot);
};
